module.exports = __webpack_public_path__ + "img/joker.df6aedb2.jpeg";